import React from 'react';
import { Link } from 'react-router-dom';
import Products from '../../Models/Products';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
class AffiliatorCart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            productDetails: [],
            sellerDetails: '',
            estimation: '',
            autoPayment: '',
            modal: { 1: false, 2: false },
        };
        this.getDetails(this.props.state.id)
        this.getSellerDetails();
        this.getEstimation(this.props.state.id);
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    toggle(i) {
        let s = this.state.modal;
        s[i] = !s[i];
        this.setState({ modal: s })
    }
    getDetails(id) {
        Products.getProductsDetails(id).then(res => {
            this.setState({ productDetails: res.data.product, autoPayment: res.renewal_type })
        })
    }
    getEstimation(id) {
        Products.getProductsDetails(id).then(res => {
            res.data.product.map(res =>
                this.setState({ estimation: res.is_estimate_or_customizable, autoPayment: res.renewal_type })
            )
        })
    }
    getSellerDetails() {
        Products.getProductsDetails(this.props.state.id).then(res => {
            this.setState({ sellerDetails: res.data.seller[0].id })
        })
    }

    openLink() {
        this.props.history.push({
            pathname: `/payment/${this.props.state.id}`,
            state: { id: this.props.state.id, flag: 'product' }
        });
    }

    autoPayment() {
        console.log(this.state.autoPayment)
        if (this.state.autoPayment == 2) {
            return (
                <span style={{ fontSize: "12px" }}>(継続課金)</span>
            )
        } else {
            return (
                <span></span>
            )
        }
    }

    askEstimation() {
        return (
            <div></div>
        )
    }
    gotoPayment() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            if (!localStorage.getItem('info')) {
                return (
                    <div style={{ textAlign: 'center' }}>
                        <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                        <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                            <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                            <ModalBody>
                                ログインしてください。
                        </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                )
            } else {
                var x = JSON.parse(localStorage.getItem('info'))
                if (x.id === this.state.sellerDetails) {
                    return (
                        <div style={{ textAlign: 'center' }} >
                            <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    自分が出品したサービスは購入出来ません！
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )
                } else if (this.props.state.self === 'NO' && x.id == this.props.state.aff_id) {
                    return (
                        <div style={{ textAlign: 'center' }} >
                            <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    自分がアフィリエイトした商品を自己購入できません！
                                    </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )
                } else if (this.props.state.available > 0) {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <Link to={{
                                pathname: `/payment/${this.props.state.id}`,
                                state: { id: this.props.state.id, flag: 'product' }
                            }} className="payment_order" target="_self" style={{ textAlign: 'center' }} >
                                <button type="submit" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >購入画面に進む </button>
                            </Link>
                        </div>
                    )
                } else {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <Button className="mb-3" style={{ textAlign: 'center', width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    現在は取り扱いしておりません。
                            </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )
                }
            }
        } else if (isDesktop) {
            if (!localStorage.getItem('info')) {
                return (
                    <div style={{ textAlign: 'center' }} >
                        <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                        <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                            <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                            <ModalBody>
                                ログインしてください。
                        </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                )
            } else {
                var x = JSON.parse(localStorage.getItem('info'))
                if (x.id === this.state.sellerDetails) {
                    return (
                        <div style={{ textAlign: 'center' }} >
                            <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    自分が出品したサービスは購入出来ません！
                            </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )
                } else if (this.props.state.self === 'NO' && x.id == this.props.state.aff_id) {
                    return (
                        <div style={{ textAlign: 'center' }} >
                            <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    自分がアフィリエイトした商品を自己購入できません！
                                    </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )
                } else if (this.props.state.available > 0) {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <Link to={{
                                pathname: `/payment/${this.props.state.id}`,
                                state: { id: this.props.state.id, flag: 'product' }
                            }} className="payment_order" target="_self" style={{ textAlign: 'center' }} >
                                <button type="submit" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >購入画面に進む </button>
                            </Link>
                        </div>
                    )
                } else {
                    return (
                        <div style={{ textAlign: 'center' }} >
                            <Button className="mb-3" style={{ width: '150px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '40px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.toggle.bind(this, 1)}>購入画面に進む</Button>
                            <Modal isOpen={this.state.modal[1]} toggle={this.toggle.bind(this, 1)} className={this.props.className}>
                                <ModalHeader toggle={this.toggle.bind(this, 1)}></ModalHeader>
                                <ModalBody>
                                    現在は取り扱いしておりません。
                            </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" onClick={this.toggle.bind(this, 1)}>閉じる</Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    )
                }
            }
        }
    }

    render() {
        return (
            <div>
                <div className="cart_inner">
                    <div className="cart_option">
                        <div className="payment_price mt-2">
                            {this.state.productDetails.map(res =>
                                <div className="">
                                    <b>{parseInt(res.price)} 円 </b>{this.autoPayment()}
                                </div>
                            )}
                        </div>
                        <div className="payment_points mt-3"> </div>
                        {this.gotoPayment()}
                        <div className="payment_points mt-3"> </div>
                        {/* {this.askEstimation()} */}
                    </div>
                </div>
            </div>
        )
    }
}
export { AffiliatorCart }